import _classCallCheck from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/marksteve/Projects/thinkingmachines/xkcd-dot/node_modules/@babel/runtime/helpers/esm/inherits";
import { RoughGenerator } from './generator';
import { RoughCanvasBase } from './canvas-base';
export var RoughCanvas =
/*#__PURE__*/
function (_RoughCanvasBase) {
  _inherits(RoughCanvas, _RoughCanvasBase);

  function RoughCanvas(canvas, config) {
    var _this;

    _classCallCheck(this, RoughCanvas);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoughCanvas).call(this, canvas));
    _this.gen = new RoughGenerator(config || null, _this.canvas);
    return _this;
  }

  _createClass(RoughCanvas, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return this.gen.defaultOptions;
    }
  }, {
    key: "line",
    value: function line(x1, y1, x2, y2, options) {
      var d = this.gen.line(x1, y1, x2, y2, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "rectangle",
    value: function rectangle(x, y, width, height, options) {
      var d = this.gen.rectangle(x, y, width, height, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "ellipse",
    value: function ellipse(x, y, width, height, options) {
      var d = this.gen.ellipse(x, y, width, height, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "circle",
    value: function circle(x, y, diameter, options) {
      var d = this.gen.circle(x, y, diameter, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "linearPath",
    value: function linearPath(points, options) {
      var d = this.gen.linearPath(points, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "polygon",
    value: function polygon(points, options) {
      var d = this.gen.polygon(points, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "arc",
    value: function arc(x, y, width, height, start, stop) {
      var closed = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var options = arguments.length > 7 ? arguments[7] : undefined;
      var d = this.gen.arc(x, y, width, height, start, stop, closed, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "curve",
    value: function curve(points, options) {
      var d = this.gen.curve(points, options);
      this.draw(d);
      return d;
    }
  }, {
    key: "path",
    value: function path(d, options) {
      var drawing = this.gen.path(d, options);
      this.draw(drawing);
      return drawing;
    }
  }, {
    key: "generator",
    get: function get() {
      return this.gen;
    }
  }]);

  return RoughCanvas;
}(RoughCanvasBase);